import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import { volumes } from '@/mocks/comicData';

export default function Volumes() {
  const [active, setActive] = useState<number>(0);

  return (
    <section id="volumes" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <div className="mx-auto max-w-2xl text-center">
            <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
              <span className="h-px w-8 bg-primary-500" />
              分卷剧情
              <span className="h-px w-8 bg-primary-500" />
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black md:text-4xl">五卷主线，一卷一段人生</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              点击任意一卷，即可展开该卷的剧情要点与精彩亮点。从开篇的单元小故事，到终局的温暖收束，脉络一目了然。
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {volumes.map((vol, i) => {
            const isOpen = active === i;
            return (
              <Reveal key={vol.no} delay={i * 60}>
                <button
                  type="button"
                  onClick={() => setActive(isOpen ? -1 : i)}
                  className={`flex h-full w-full flex-col rounded-lg border p-5 text-left transition-all duration-300 ${
                    isOpen
                      ? 'border-primary-300 bg-primary-50/70 shadow-sm'
                      : 'border-background-200/70 bg-background-100 hover:border-primary-200 hover:bg-background-50'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span className="font-heading text-sm font-bold tracking-wider text-primary-600">{vol.no}</span>
                    <span className="rounded-full bg-accent-100 px-3 py-0.5 text-xs font-medium text-accent-700">
                      {vol.tag}
                    </span>
                  </div>
                  <h3 className="mt-3 font-heading text-xl font-black">{vol.title}</h3>
                  <p
                    className={`mt-2 text-sm leading-relaxed text-foreground-700 transition-all ${
                      isOpen ? '' : 'line-clamp-2'
                    }`}
                  >
                    {vol.summary}
                  </p>

                  {isOpen && (
                    <ul className="mt-4 flex flex-wrap gap-2">
                      {vol.highlights.map((h) => (
                        <li
                          key={h}
                          className="inline-flex items-center gap-1.5 rounded-full bg-background-50 px-3 py-1 text-xs text-foreground-700 ring-1 ring-background-200/70"
                        >
                          <i className="ri-sparkling-line text-accent-500" />
                          {h}
                        </li>
                      ))}
                    </ul>
                  )}

                  <span
                    className={`mt-4 inline-flex items-center gap-1 text-xs font-medium ${
                      isOpen ? 'text-accent-600' : 'text-primary-600'
                    }`}
                  >
                    {isOpen ? '收起本卷' : '展开本卷亮点'}
                    <i className={`ri-arrow-down-s-line transition-transform ${isOpen ? 'rotate-180' : ''}`} />
                  </span>
                </button>
              </Reveal>
            );
          })}

          <Reveal delay={300}>
            <div className="flex h-full min-h-[220px] flex-col items-start justify-center rounded-lg bg-gradient-to-br from-primary-500 to-accent-500 p-6 text-background-50">
              <i className="ri-quill-pen-line text-3xl" />
              <h3 className="mt-3 font-heading text-lg font-bold">还有支线与番外</h3>
              <p className="mt-2 text-sm leading-relaxed text-background-100/90">
                除五卷主线外，洞洞杂货铺漫画还穿插少量支线短篇与角色番外，补全配角的前史。想系统追更，可在下方「追更动态」查看最新话。
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}